module.exports = __webpack_public_path__ + "img/mon_24.e7060734.png";